import produce from "immer";
import { CustomizationState } from "../..";

export interface SetGalleryAction {
  type: "setGallery";
  fixedLayout?: boolean;
  open: boolean;
  pageKey?: string;
  undoKey?: string;
}

export function setGallery(
  state: CustomizationState,
  action: SetGalleryAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { fixedLayout, open, pageKey, undoKey } = action;

    draftState.ui.gallery.opened = open;
    draftState.ui.gallery.fixedLayout = fixedLayout ? fixedLayout : false;

    if (pageKey) {
      draftState.ui.gallery.pageKey = pageKey;
    } else {
      draftState.ui.gallery.pageKey = undefined;
    }

    if (undoKey) {
      draftState.ui.gallery.undoKey = undoKey;
    } else {
      draftState.ui.gallery.undoKey = undefined;
    }
  });
}
